export const PORTAL_TYPE = `CP`;